<template>
  <TjpaDemandasFormPesquisa />
  <div>
    <q-table
      class="fit"
      :columns="columns.map(column => ({ ...column, align: 'left' }))"
      row-key="id"
      :rows="rows"
      @row-click="(evt, row) => $router.push(`/tema/${row.numero}`)"
      @request="request"
      v-model:pagination="_pagination"
    >
      <template v-slot:body-cell-acoes="tema">
        <q-td :props="tema">
          <q-btn
            flat
            icon="delete_outline"
            title="Excluir Tema"
            @click.stop="deleteTema(tema.row.numero)"
            v-if="admin"
          />
        </q-td>
      </template>
    </q-table>
    <AppConfirmModal v-model="confirmThemeDeletion" question="Tem certeza de que deseja excluir o Tema?" @ok="excluirTema(idTemaExcluir)" />
  </div>
</template>


<script setup>
import TjpaDemandasFormPesquisa from "@/components/tjpa-demandas-form-pesquisa.vue";
import AppConfirmModal from "@/components/app/AppConfirmModal.vue"
import { useTemaSituacaoStore } from "@/store/tema-situacao-store";
import { defineProps, defineEmits, ref, computed } from "vue";
import { useUserStore } from "@/store/user-store";
const userStore = useUserStore();
const situacaoStore = useTemaSituacaoStore();
situacaoStore.fetch();

const props = defineProps({
  rows: {},
  pagination: {},
  headers: {
    type: Array,
    default: Array.from([
      "pje",
      "tema",
      "tese",
      "situacao",
      "acoes"
    ])
  }
});


const emit = defineEmits(["del", "update:pagination", "request"]);
const request = v => emit("request", v);
const _pagination = computed({
  get: () => props.pagination,
  set: v => emit("update:pagination", v)
});

const admin = computed(() => userStore.admin);
const nomeSituacaoFromId = id =>
  situacaoStore.all.find(situacao => situacao.id == id)?.descricao;

const confirmThemeDeletion = ref(false);
const idTemaExcluir = ref(0);
const deleteTema = id => {
  idTemaExcluir.value = id;
  confirmThemeDeletion.value = true;
};

const excluirTema = id => emit("del", id);
const allcolumns = computed(()=>[
  {
    name: "pje",
    label: "Tema",
    field: "numero"
  },
  {
    name: "tema",
    label: "Questão submetida a julgamento",
    field: "questao",
    style: () => `overflow: hidden;text-overflow: ellipsis; max-width: 20vw; white-space: pre-wrap;`
  },
  {
    name: "tese",
    label: "Tese jurídica fixada",
    field: "tese",
    style: () => `overflow: hidden;text-overflow: ellipsis; max-width: 20vw; white-space: pre-wrap;`
  },
  {
    name: "situacao",
    label: "Situação",
    field: "idSituacaoTema",
    format: id => `${nomeSituacaoFromId(id)}`
  },
  { name: "questao", label: "Questão", field: "questao" },
  userStore.admin? { name: "acoes", label: "Ações", field: "acoes" } : {}
]);

const columns = computed(() =>
  allcolumns.value.filter(c => props.headers.includes(c.name))
);
</script>
